<nav>
  <ol>
    @for (crumb of crumbs; track crumb) {
      <li>
        <a class="btn btn-light" [routerLink]="crumb.path">{{crumb.label}}</a>
        <fa-icon class="chevron" [icon]="faChevronRight"></fa-icon>
      </li>
    }
  </ol>
</nav>
